import React from 'react';

import { Icon } from '@gumtree/ui-library';

import { Title } from '../../common';
import HPILogo from './hpi-logo';

const Header: React.FC = () => (
    <Title>
        <Icon type="vhc" />
        Vehicle history
        <HPILogo />
    </Title>
);

export default Header;
